import { render, staticRenderFns } from "./WarningSeting.vue?vue&type=template&id=0d6e388c&"
import script from "./WarningSeting.vue?vue&type=script&lang=js&"
export * from "./WarningSeting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports